import constants from '@/app-configs/constants'

export default [
  {
    title: 'DEBTIA_USERS',
    icon: 'UserIcon',
    action: constants.action.permissionUserView,
    resource: constants.resource.user,
    children: [
      {
        title: 'DEBTIA_LIST',
        route: 'users-list',
        action: constants.action.permissionUserView,
        resource: constants.resource.user,
      },
      {
        title: 'DEBTIA_ADD',
        route: 'users-add',
        action: constants.action.permissionUserAdd,
        resource: constants.resource.user,
      },
      /* {
        title: 'View',
        route: { name: 'users-view', params: { id: 21 } },
        action: 'view',
        resource: constants.resource.user,
      },
      {
        title: 'Edit',
        route: { name: 'users-edit', params: { id: 21 } },
        action: 'edit',
        resource: constants.resource.user,
      }, */
    ],
  },
  /* {
    title: 'Users',
    route: 'users-list',
    icon: 'HomeIcon',
    action: 'view',
    resource: constants.resource.user,
  },
  {
    title: 'Edit Users',
    route: 'second-page',
    icon: 'FileIcon',
    action: 'rule',
    resource: 'MyRule',
  }, */
]
